import React from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import FieldContainer from "./FieldContainer";
import Label from "./Label";
import { wrapperClasses } from "./styles";

import type { JSX } from "react";

import type { InputProps } from "./types";

type SwitchUsingFormContextProps = InputProps & {
  labelClassNames?: string;
  color?: string;
};

export default function SwitchUsingFormContext({
  name,
  label,
  sublabel,
  infoText,
  isRequired = false,
  isReadOnly = false,
  defaultValue,
  isCompact,
  className,
  isNoWrap,
  labelClassNames,
  isReversed,
  color,
}: SwitchUsingFormContextProps): JSX.Element {
  const { register, watch } = useFormContext();
  const { t } = useTranslation("editor-errors");

  const value = watch(name);

  return (
    <FieldContainer
      className={className}
      isCompact={isCompact}
      isNoWrap={isNoWrap}
      isReversed={isReversed}
    >
      {label ? (
        <Label
          isCompact={isCompact}
          isRequired={isRequired}
          isStartLabel={false}
          label={label}
          name={name}
          sublabel={sublabel}
        />
      ) : null}
      <div className={wrapperClasses({ isCompact, isReversed })}>
        <div className="flex items-center gap-[0.78125rem]">
          <label
            className={labelClassNames}
            htmlFor={name}
            style={{
              backgroundColor: value && color ? color : "",
            }}
          >
            <input
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...register(name, {
                required: isRequired && t("requiredField"),
              })}
              className="invisible size-0"
              defaultValue={defaultValue}
              disabled={isReadOnly}
              id={name}
              type="checkbox"
            />
          </label>
          {infoText}
        </div>
      </div>
    </FieldContainer>
  );
}
